import ADMIN_CONST from 'const/admin-const';

function guard() {

    let userSession:any = localStorage.getItem(ADMIN_CONST.KEY_STORE_USER);
    if (userSession === null || userSession === undefined) return false;
    
    userSession = JSON.parse(userSession as 'string');
    if (!userSession || !userSession.token) return false;

    const currentTime = Math.floor(new Date().getTime() / 1000);
    if (userSession.exp && userSession.exp < currentTime) {

        alert('User Expired');
        return false;
    }

    // if (!userSession.centers.includes('center-admin')) {
    //     alert('Access Denied' +  JSON.stringify(userSession.roles));
    //     return false;
    // }

    return true;
}
export default guard;